<template>
    <div class="pml_sent_mail">
        <div v-html="body" class="show_mail"></div>
        <div v-if="trackers.length">
            <p class="pump_mail_title">
                <strong>{{ $t('activities') }}:</strong> {{ $t('deal') }}
            </p>
            <div class="pump_mail" v-for="(item, index) in trackers">
                <p class="divider"><strong>{{ $t('status') }}:</strong> {{ $t(item.event) }}</p>
                <p class="divider t_right"><strong>{{ $t('date') }}:</strong> {{ item.timestamp | pmlDate('DD/MM/YYYY HH:mm:ss') }}</p>
                <p><strong>{{ $t('email') }}:</strong> {{ item.recipient }}</p>
                <p v-if="item.content.url"><strong>{{ $t('link') }}:</strong> {{ item.content.url }}</p>
                <p v-if="item.content.reason"><strong>{{ $t('reason') }}:</strong> {{ item.content.reason }}</p>
            </div>
        </div>
        <div v-if="copyTrackers.length">
            <p class="pump_mail_title">
                <strong>{{ $t('activities') }}:</strong> {{ $t('copies') }}
            </p>
            <div class="pump_mail" v-for="(item, index) in copyTrackers">
                <p class="divider"><strong>{{ $t('status') }}:</strong> {{ $t(item.event) }}</p>
                <p class="divider t_right"><strong>{{ $t('date') }}:</strong> {{ item.timestamp | pmlDate('DD/MM/YYYY HH:mm:ss') }}</p>
                <p><strong>{{ $t('email') }}:</strong> {{ item.recipient }}</p>
                <p v-if="item.content.url"><strong>{{ $t('link') }}:</strong> {{ item.content.url }}</p>
                <p v-if="item.content.reason"><strong>{{ $t('reason') }}:</strong> {{ item.content.reason }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { getByCode, get } from 'services/emails'
    import { filter, orderBy } from 'lodash'

    export default {
        name: 'EmailShow',
        data () {
            return {
                record: {},
                body: ''
            }
        },
        computed: {
            trackers () {
                return orderBy(filter(this.record.trackers, { recipient: this.record.to }), [ 'timestamp' ], [ 'desc' ]) || []
            },
            copyTrackers () {
                return orderBy(filter(this.record.trackers, (obj) => obj.recipient !== this.record.to), [ 'timestamp' ], [ 'desc' ]) || []
            }
        },
        mounted () {
            this.getRequest()
                .then(response => {
                    this.record = response.data.email
                    this.body = response.data.body
                })
        },
        methods: {
            getRequest () {
                return typeof this.$route.params.id !== 'undefined'
                    ? get(this.$route.params.id, this.$route.params.email)
                    : getByCode(this.$route.params.code)
            }
        }
    }
</script>

<style lang="scss">
    .pml_sent_mail {
        padding: 15px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;

        .show_mail {
            background-color: #fff;
            margin-bottom: 20px;
            padding: 20px;
            border-radius: 6px;
            width: 100%;
            font-family: Arial, sans-serif;
            font-size: 14px;
            color: #505458;

            p {
                margin-bottom: 10px;
            }

            b, strong, h1, h2, h3, h4, h5, h6 {
                font-weight: 600;
            }

            h1 {
                font-size: 2em;
                margin: 0.67em 0;
            }

            h2 {
                font-size: 1.5em;
                margin: 0.83em 0;
            }

            h3 {
                font-size: 1.17em;
                margin: 1.0em 0;
            }

            h4 {
                font-size: 1em;
                margin: 1.33em 0;
            }

            h5 {
                font-size: 0.83em;
                margin: 1.67em 0;
            }

            h6 {
                font-size: 0.67em;
                margin: 2.33em 0;
            }

            p, h1, h2, h3, h4, h5, h6 {
                font-family: Arial, sans-serif;
            }

            .table > tbody > tr th,
            .table > tbody > tr td,
            .table > tfoot > tr th,
            .table > tfoot > tr td,
            .table > thead > tr th,
            .table > thead > tr td {
                vertical-align: middle;
                padding: 8px;
                color: #505458;
            }

            .table.table-bordered {
                border: solid 1px transparent;

                tbody tr td,
                thead tr th {
                    border: solid 1px transparent;
                }
            }
        }

        .pump_mail_title {
            border-top: dashed 1px #ccc;
            margin: 20px 0 10px;
            color: #777;
            font-family: Arial;
            font-size: 15px;
            letter-spacing: 0.5px;
            padding-top: 10px;
        }

        .pump_mail {
            font-family: Arial;
            width: calc(100% - 10px);
            font-size: 12px;
            background-color: #fff;
            padding: 7px 10px;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            border-left: solid 2px #ddd;
            position: relative;
            margin: 0 0 0 10px;
            border-top: solid 1px #ddd;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;

            &:after {
                position: absolute;
                content: "";
                display: block;
                left: -4px;
                top: -4px;
                width: 6px;
                height: 6px;
                background: #ccc;
                -webkit-transform: rotateZ(45deg);
                -ms-transform: rotateZ(45deg);
                transform: rotateZ(45deg);
            }

            p {
                margin: 0;
            }
        }
    }

    .divider {
        width: 50%;
        float: left;
    }

    .t_right {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/modules/emails/components/Show.vue